import { differenceInCalendarDays, isAfter, isBefore } from "date-fns";
import { createSelector } from "@reduxjs/toolkit";

export const selectIsLabelsLoaded = (state) => {
  const labels = state.labels;
  const { locale, area } = state.configs; // o dove hai salvato i configs
  return (
    labels?.[locale]?.[area] &&
    Object.keys(labels?.[locale]?.[area] || {}).length > 0
  );
};
// Original non-memoized version (deprecated, use selectOperationByIdMemo instead)
export const selectOperationById = (id) => (state) => {
  console.log('DEBUG selectOperationById: id=', id, 'operations.length=', state.operations?.length);
  const found = state.operations?.find((op) => op.id === id) ||
    state.completedOperations?.find((op) => op.id === id);
  console.log('DEBUG selectOperationById: found=', found?.id, 'start_date=', found?.start_date);
  return found;
}

// Memoized version using createSelector to prevent unnecessary re-evaluations
export const selectOperationByIdMemo = (id) => createSelector(
  [(state) => state.operations, (state) => state.completedOperations],
  (operations, completedOperations) => {
    // console.log('DEBUG selectOperationByIdMemo: id=', id, 'operations.length=', operations?.length);
    const found = operations?.find((op) => op.id === id) ||
      completedOperations?.find((op) => op.id === id);
    // console.log('DEBUG selectOperationByIdMemo: found=', found?.id, 'start_date=', found?.start_date);
    return found;
  }
);
export const selectLabels = (state) => state.labels;
export const selectUser = (state) => state.user;
export const selectUserRbacPermissions = (state) => state.user.activeWineryPermissions;
export const selectConfigs = (state) => state.configs;
export const selectHistory = (state) => state.history;
export const selectWineries = (state) => state.wineries.list;
export const selectWineryDisplayGrid = (state) =>
  state.configs.wineriesDisplayGrid;
export const selectActiveWinery = (state) => state.wineries.active;
export const selectImpersonationActive = (state) => state.impersonation.active;
export const selectImpersonationSavedAdminAuth = (state) => state.impersonation.savedAdminAuth;
export const selectTanks = (state) => state.tanks;
export const selectWineLabels = (state) => state.wineLabels;
export const selectWineVarieties = (state) => state.wineVarieties;
export const selectTankDisplayGrid = (state) => state.configs.tanksDisplayGrid;
export const selectOperations = (state) => state.operations;
export const selectCompletedOperations = (state) => state.completedOperations;
export const selectPermissions = (state) => state.permissions;
export const selectResources = (state) => state.resources;
export const selectUsers = (state) => state.users;
export const selectSensors = (state) => state.sensors;
export const selectWarehouseByType = (type) => (state) => state.warehouse?.[type] || [];
export const selectNextOperations = (state, dates) =>
  state.operations.filter(
    (operation) =>
      isBefore(new Date(operation.expire_date), dates.endDate) &&
      isAfter(new Date(operation.expire_date), dates.startDate) // ||
    // (isBefore(new Date(operation.insertion_date), dates.endDate) &&
    //   isAfter(new Date(operation.insertion_date), dates.startDate))
  );

// export const selectNextOperationsByTank = (state, dates, tankId) => state.operations.filter((operation) => {
//     return (
//         !operation.completion_date &&
//         (operation?.dest_tanks?.some?.((tank) => Number(tank.tank_id) === tankId) ||
//         operation?.src_tanks?.some?.((tank) => Number(tank.tank_id) === tankId)) &&
//         (isBefore(new Date(operation.expire_date), dates.endDate) &&
//             isAfter(new Date(operation.expire_date), dates.startDate)) ||
//         (isBefore(new Date(operation.insertion_date), dates.endDate) &&
//             isAfter(new Date(operation.insertion_date), dates.startDate))
//     )
// })

export const selectNextOperationsByType = (state, dates, id, type) =>
  [...state.operations, ...state.expOperations]?.filter((operation, index) => {
    if (type === "TANK")
      return (
        !operation.completion_date &&
        (operation?.dest_tanks?.some?.((tank) => Number(tank.tank_id) === id) ||
          operation?.src_tanks?.some?.(
            (tank) => Number(tank.tank_id) === id
          )) &&
        (index >= state.operations?.length ||
          (index < state.operations?.length &&
            isBefore(new Date(operation.expire_date), dates.endDate) &&
            isAfter(new Date(operation.expire_date), dates.startDate)) ||
          (isBefore(new Date(operation.insertion_date), dates.endDate) &&
            isAfter(new Date(operation.insertion_date), dates.startDate)))
      );
    else
      return (
        !operation.completion_date &&
        (operation?.batch_id_in === id ||
          operation?.dest_tanks?.some?.(
            (tank) => Number(tank.batch_id) === id
          ) ||
          operation?.src_tanks?.some?.(
            (tank) =>
              Number(tank.batch_id) === id ||
              Number(tank?.preOperation?.batch?.id) === id
          )) &&
        (index >= state.operations?.length ||
          (index < state.operations?.length &&
            isBefore(new Date(operation.expire_date), dates.endDate) &&
            isAfter(new Date(operation.expire_date), dates.startDate)) ||
          (isBefore(new Date(operation.insertion_date), dates.endDate) &&
            isAfter(new Date(operation.insertion_date), dates.startDate)))
      );
  });

export const selectToBeCompletedOperations = (state) =>
  state.operations.filter((operation) => !operation.completion_date);
export const selectExpiringOperations = (state) =>
  state.operations.filter(
    (operation) =>
      !operation.completion_date &&
      differenceInCalendarDays(new Date(operation.expire_date), new Date()) <= 7
  );
export const selectExpiredOperations = (state) =>
  state.expOperations.filter(
    (operation) => (
      !operation.completion_date &&
      differenceInCalendarDays(new Date(operation.expire_date), new Date()) < 0)
  ) || [];

export const selectUnits = (state) => state.units;
export const selectDrugs = (state) => state.drugs;
export const selectWineMaking = (state) => state.wineMaking;
export const selectExams = (state) => state.exams;
export const selectStoredAnalysisResults = (state) => state.analysisResults;
export const selectSubstancesDisplayGrid = (state) =>
  state.configs.substancesDisplayGrid;
export const selectSubstancesWarehouseDisplayGrid = (state) =>
  state.configs.toggleSubstancesWarehouseDisplayGrid
export const selectTreatments = (state) => state.treatments;
export const selectTreatmentsDisplayGrid = (state) =>
  state.configs.treatmentsDisplayGrid;
export const selectAnalysis = (state) => state.analysis;
export const selectAnalysisDisplayGrid = (state) =>
  state.configs.analysisDisplayGrid;
export const selectClients = (state) => state.clients;
export const selectClientDisplayGrid = (state) =>
  state.configs.clientsDisplayGrid;
export const selectRealView = (state) => state.configs.realView;
export const selectLotDisplayGrid = (state) => state.configs.lotsDisplayGrid;
export const selectLots = (state) => state.lots;
export const selectProtocolDisplayGrid = (state) =>
  state.configs.protocolsDisplayGrid;
export const selectUsersDisplayGrid = (state) => state.configs.usersDisplayGrid;
export const selectNotificationsUnread = (state) =>
  state.configs.notificationsUnreadGrid;
export const selectUserSockets = (state) => state.userSockets;
export const selectAllLotNames = (state) => {
  const lotNames = new Set();
  state.lots?.reduce(
    (_, item) => lotNames.add({ name: item?.name, state: item?.state, color: item?.color, batch_type: item?.batch_type, status: item?.status, id: item?.id, shared_operation_ids: item?.shared_operation_ids }),
    null
  );
  state.operations?.map((o) =>
    o?.dest_tanks
      ?.filter((d) => d?.new_batch_type !== "OLD" && d?.new_batch_name)
      ?.reduce(
        (_, item) =>
          lotNames.add({ name: item?.new_batch_name, ...(getStateColor(o, state.lots)) }),
        null
      )
  );

  return Array.from(lotNames);
};
export const selectBottleTypes = () => {
  return [
    { value: "SMALL", volume: 0.1875 },
    { value: "DEMI", volume: 0.375 },
    { value: "STANDARD", volume: 0.75 },
    { value: "MAGNUM", volume: 1.5 },
    { value: "JEROBOAM", volume: 3 },
    { value: "REHOBOAM", volume: 4.5 },
  ];
}
export const selectMachineryTypes = () => {
  return [
    { value: "BOTTLING_MACHINE" },
  ];
}
const getStateColor = (operation, lots) => {
  const tmp = {};
  const src = operation?.src_tanks?.[0] || {};
  tmp.color = src?.color || 'RED';

  switch (operation?.type) {
    case "DESTEMMING":
      tmp.state = "MUST";
      break;
    case "RACKING":
      tmp.state = "WINE";
      break;
    case "BOTTLING":
      tmp.state = "BOTTLED";
      break;
    default:  // RACKING CUT NEW_LOT TANNISSAGE BOIS ENZYME SO2 HOMOGENIZATION_MASS OXYGENATION NITROGEN INOCULATION BOTTLING"
      tmp.state = src?.state || lots?.find((lot) => lot?.id === src?.batch_id)?.state;
      break;
  }
  return tmp;
}
export const selectVirtualTanks = (state) => {
  const virtualTanks = [];
  for (const tank of state.tanks) {
    const virtualTank = {
      ...tank,
    };
    const relatedOps = state.operations?.filter(
      (o) =>
        !["ANALYSIS", "TREATMENT"].includes(o?.type) &&
        (o?.src_tanks?.some((s) => s.tank_id === tank?.id) ||
          o?.dest_tanks?.some((s) => s.tank_id === tank?.id))
    );
    for (const op of relatedOps) {
      if (op?.type === "CUT") {
      } else {
        const opDest = op?.dest_tanks?.find((s) => s.tank_id === tank?.id);
        // Only update virtual state when this tank is a destination of the operation.
        // Skipping source-only tanks prevents incorrectly clearing batch_id and
        // producing NaN quantities (which made wine-holding tanks appear empty).
        if (opDest) {
          const { color: vColor, state: vState } = getStateColor(op, state.lots);
          virtualTank.batch_id = null;
          virtualTank.batch_name = opDest?.new_batch_name;
          virtualTank.color = vColor;
          virtualTank.quantity = Number(tank?.quantity) + (opDest?.quantity != null ? Number(opDest.quantity) : 0);
          virtualTank.state = vState;
        }
      };
    }
      virtualTanks.push(virtualTank);
    }

  return virtualTanks;
};
export const selectSuppliers = (state) => state.suppliers;
export const selectVineyards = (state) => state.vineyards;
export const selectApplications = (state) => state.applications;
export const selectAppTemplates = (state) => state.appTemplates;
export const selectProtocolAppDraft = (state) => state.protocolApplicationDraft;
